var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-tab"},_vm._l((_vm.list),function(item,i){return _c('div',{key:i,staticClass:"ui-tab-item",on:{"click":function($event){return _vm.$emit('change', i)}}},[_c('span',{class:{ 'try': _vm.hasTry&&i===1 , 'on': _vm.index === i}},[_vm._v(_vm._s(item.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }